import { useNativeAuth } from 'auth/hooks/useNativeAuth';
import { useProfile } from 'core-lib/hooks/useProfile';
import { useState } from 'react';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { Button } from 'ui-v2/components/Button';
import { trackSuggestProductClicked } from '../../utils/events';
import SuggestProduct from '../SuggestProduct';
import s from './StoreFooter.module.scss';

export const StoreFooter = () => {
  //state
  const [showSuggestProduct, setShowSuggestProduct] = useState(false);
  //hook
  const { login } = useNativeAuth();
  const { isAuthenticated } = useProfile();

  const checkAuth = async (callback) => {
    if (isAuthenticated) {
      callback();
    } else {
      const res = await login();
      if (res) {
        callback();
      }
    }
  };

  return (
    <div className={s.root}>
      <div className={s.suggest_product}>
        <AnimatedImage
          src="https://parkplus-bkt-img.parkplus.io/production/team/public/FS_20240105133635117099.png"
          customStyle={{ minHeight: 161 }}
        />
        <Button
          label="Suggest a Product"
          variant="secondary_color"
          size='small'
          onClick={() =>
            checkAuth(() => {
              trackSuggestProductClicked();
              setShowSuggestProduct(true);
            })
          }
        />
      </div>

      <SuggestProduct
        show={showSuggestProduct}
        onHide={() => setShowSuggestProduct(false)}
      />
    </div>
  );
};
